<template>
  <el-dialog :visible.sync="dialogVisible" v-loading="qrcodeLoading" :destroy-on-close="true" @close="onclose" title="人脸识别" top="10vh"
    class="dp-dialog">
    <div class="">
      <div class="main-page">
        <div class="revokebackgroundBox">
          <div class="tip-text">
            <span>请用微信扫描下方二维码，进入上海复议小程序进行人脸识别认证</span>
          </div>
          <div class="main-contentBox" @click="refreshQrCode">
            <img v-if="qrcodeUrl" :src="qrcodeUrl" alt="小程序二维码" style="width: 280px; height: 280px" />
          </div>
          <div class="tip-text-refresh">
            <span><i class="el-icon-refresh"></i>请点击二维码刷新</span>
          </div>
          <div class="btn-item">
            <el-button type="primary" @click="back_prev">返回上一页</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@api/api'
import axios from 'axios'
export default {
  props: {
    // caseOrderNo: {
    //   type: String,
    //   required: true
    // },
    // inquireNo: {
    //   type: String,
    //   required: true
    // },
  },
  data () {
    return {
      checked: false,
      isShow: false,
      searchType: 0,
      downNumber: 5, // 倒数字
      dialogVisible: false,
      qrcodeUrl: '',
      qrcodeLoading: false,
      authenticatedTimer: null,
    }
  },
  created () {

  },
  // 组件销毁前清除定时器
  beforeDestroy () {
    if (this.authenticatedTimer) {
      clearTimeout(this.authenticatedTimer)
      this.authenticatedTimer = null
    }
  },
  methods: {
    open (searchType) {
      this.dialogVisible = true;
      this.searchType = searchType // 存储是申请还是收案案件
      this.getQrCode();
    },
    onclose () {
      this.dialogVisible = false;
      clearTimeout(this.authenticatedTimer)
      this.authenticatedTimer = null;
    },
    refreshQrCode () {
      // 清除之前的轮询定时器
      if (this.authenticatedTimer) {
        clearTimeout(this.authenticatedTimer)
        this.authenticatedTimer = null
      }
      this.getQrCode()
    },
    back_prev () {
      this.onclose();
      this.$parent.confirmDialog = true;
    },
    // 获取微信小程序二维码
    getQrCode () {
      this.qrcodeLoading = true;
      Api.getToken().then(res => {
        this.getCode(res.data.data.accessToken);
      }).catch(() => {
        this.qrcodeLoading = false;
      }).finally(() => {
        this.qrcodeLoading = false;
      });
    },
    getCode (access_token) {
      let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo'))
      console.log('我进来了--- token是',access_token);
      // console.log(this.applicantInfo, applicantInfo.identificationCard);
      console.log(1);
      
      // 获取用户id
      Api.postUserFaceInsert({
        name: applicantInfo ? applicantInfo.loginName : '',
        idNumber: applicantInfo ? applicantInfo.identificationCard : ''
      }).then(res => {
        console.log(res);
        
        this.qrcodeId = res.data.data
        axios.post(
          'https://xzfysq.sfj.sh.gov.cn/wx/wxa/getwxacodeunlimit?access_token=' + access_token,
          {
            page: 'pages/face/face',
            scene: this.qrcodeId,
            env_version: window.g.wxMiniEnvVersion, // 从配置文件读取环境版本
            width: 280
          },
          {
            responseType: 'arraybuffer', // 关键配置：指定接收二进制数据
            headers: { 'Content-Type': 'application/json' }
          }
        ).then(res => {
          console.log(res)
          // 将二进制流转为图片 URL
          const imgUrl = URL.createObjectURL(new Blob([res.data], { type: 'image/jpg' }));
          // 将URL赋值给data中的变量，用于在模板中显示
          this.qrcodeUrl = imgUrl
          this.getUserFaceAuthenticated()
        }).catch(err => {
          console.error('获取二维码失败:', err)
        }).finally(() => {
          this.qrcodeLoading = false
        })
      })
    },
    // 轮询判断认证是否完成
    getUserFaceAuthenticated () {
      if (this.authenticatedTimer) {
        clearTimeout(this.authenticatedTimer)
        this.authenticatedTimer = null
      }
      Api.getUserFaceAuthenticated(this.qrcodeId).then(res => {
        console.log('判断是否人脸识别已完成成功or 失败', res)
        if (res.data.data == 0) {
          this.authenticatedTimer = setTimeout(() => {
            this.getUserFaceAuthenticated()
          }, 1000)
        } else if (res.data.data == 1) {
          this.nextTep()
        } else if (res.data.data == 2) {
          this.$message.error('人脸识别失败')
          this.returnRegisterPage()
        } else {
          this.$message.error('网络错误')
          // 网络错误时关闭弹窗
          this.onclose()
        }
      }).catch(err => {
        console.error('人脸识别轮询出错:', err)
        this.$message.error('网络错误')
        this.onclose()
      })
    },
    // 认证成功后的处理
    nextTep () {
      // 清除定时器
      if (this.authenticatedTimer) {
        clearTimeout(this.authenticatedTimer)
        this.authenticatedTimer = null
      }
      this.$message.success('人脸识别成功')
      // 触发父组件的事件或进行后续操作
      this.$emit('nextTep');
      this.dialogVisible = false;
    },
    // 返回注册页面
    returnRegisterPage () {
      // 清除定时器
      if (this.authenticatedTimer) {
        clearTimeout(this.authenticatedTimer)
        this.authenticatedTimer = null
      }
      this.onclose()
    },
    // // 撤回
    // interApply () {
    //   const withdrawSource = +this.$route.query.searchType + 1
    //   let loading = this.$loading({
    //     Lock: true,
    //     text: '处理中',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   })
    //   Api.WithdrawApplyExportWord({
    //     caseOrderNo: this.caseOrderNo,
    //     withdrawSource
    //   }).then(({ data }) => {
    //     this.$emit('openCh', data)
    //   }).finally(() => {
    //     loading.close()
    //     loading = null
    //     this.dialogVisible = false
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .dp-dialog {
  ::v-deep .el-dialog {
    width:300px !important;

    .el-dialog__body {
      height: 500px !important;
      overflow-y: auto;
    }
  }
}
}

.dp-dialog {
  ::v-deep .el-dialog {
    width: 596px ;

    .el-dialog__body {
      height: 500px !important;
      overflow-y: auto;
    }
  }
}
.main-page {
  height: 100%;
  .tip-text {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .tip-text-refresh {
    margin: 20px 0px;
  }
}

.revokebackgroundBox {
  flex: 1;
  background-size: 104% 104%;
  background-position: -22px 0px !important;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.main-contentBox {
  cursor: pointer;
  width: 280px;
  height: 280px;
}
</style>
